import {FunctionComponent} from "react";
import './scroll-tracker.scss';

type ScrollTrackerProps = {
    maxValue: number,
    currentValue: number
}
const ScrollTracker:FunctionComponent<ScrollTrackerProps> = ({maxValue, currentValue}) => {
    return(
        <div className="sroll-tracker">
            <div className="tracker-foreground" style={{height: `${(currentValue / maxValue ) * 100}%`}}/>
        </div>
    )
}
export default ScrollTracker